import React from 'react'
import { Link } from 'react-router-dom'

type Props = {
  staticLinks?: boolean
}

const TermsContent = ({ staticLinks }: Props) => {
  const HomeLink = staticLinks ? (
    <a href='/'>← Back to home</a>
  ) : (
    <Link to='/'>← Back to home</Link>
  )

  const PrivacyLink = staticLinks ? (
    <a href='/privacy'>Privacy Policy</a>
  ) : (
    <Link to='/privacy'>Privacy Policy</Link>
  )

  return (
    <>
      <p className='faq-back'>{HomeLink}</p>
      <h1 className='faq-title'>Terms and conditions</h1>

      <section className='faq-section'>
        <h2 className='faq-question'>Introduction</h2>
        <p className='faq-answer'>
          Welcome to TinyInvoice.app (the &quot;Service&quot;). These Terms and Conditions (&quot;Terms&quot;) govern your use of the Service. By using the Service, you agree to be bound by these Terms. If you do not agree, please do not use the Service.
        </p>
      </section>

      <section className='faq-section'>
        <h2 className='faq-question'>User obligations</h2>
        <p className='faq-answer'>By using the Service, you represent and warrant that:</p>
        <ul className='faq-list'>
          <li>You are at least 18 years of age or the legal age of majority in your jurisdiction, whichever is higher.</li>
          <li>You will not use the Service for any illegal purpose.</li>
          <li>You will not use the Service to infringe any intellectual property rights or other proprietary rights of any third party.</li>
          <li>You will not use the Service to harm, harass, or otherwise interfere with the rights of others.</li>
        </ul>
      </section>

      <section className='faq-section'>
        <h2 className='faq-question'>Intellectual property</h2>
        <p className='faq-answer'>
          The Service, including its design, code, and content, is protected by copyright, trademark, and other intellectual property laws. You acknowledge and agree that all intellectual property rights in and to the Service are owned by us or our licensors.
        </p>
      </section>

      <section className='faq-section'>
        <h2 className='faq-question'>Privacy</h2>
        <p className='faq-answer'>
          Our {PrivacyLink} sets out how we process personal data we collect from you or that you provide to us. By using the Service, you consent to such processing and you warrant that all data you provide is accurate.
        </p>
      </section>

      <section className='faq-section'>
        <h2 className='faq-question'>Disclaimer of warranties</h2>
        <p className='faq-answer'>
          The Service is provided &quot;as is&quot; and without warranty of any kind, either express or implied, including, but not limited to, the implied warranties of merchantability, fitness for a particular purpose, and non-infringement. We do not warrant that the Service will be uninterrupted or error-free.
        </p>
      </section>

      <section className='faq-section'>
        <h2 className='faq-question'>Limitation of liability</h2>
        <p className='faq-answer'>
          In no event shall we be liable for any direct, indirect, incidental, special, or consequential damages arising out of or in connection with the use of the Service, whether based on contract, tort, strict liability, or otherwise, even if we have been advised of the possibility of such damages.
        </p>
      </section>

      <section className='faq-section'>
        <h2 className='faq-question'>Indemnification</h2>
        <p className='faq-answer'>
          You agree to indemnify, defend, and hold harmless us, our affiliates, and our respective officers, directors, employees, agents, licensors, and suppliers from and against all claims, losses, liabilities, expenses, damages, and costs, including reasonable attorneys&apos; fees, arising out of or in connection with your use of the Service or your breach of these Terms.
        </p>
      </section>

      <section className='faq-section'>
        <h2 className='faq-question'>Governing law</h2>
        <p className='faq-answer'>
          These Terms and your use of the Service shall be governed by and construed in accordance with the laws of Spain.
        </p>
      </section>

      <section className='faq-section'>
        <h2 className='faq-question'>Changes to the Terms</h2>
        <p className='faq-answer'>
          We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days&apos; notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
        </p>
      </section>

      <section className='faq-section'>
        <h2 className='faq-question'>Termination</h2>
        <p className='faq-answer'>
          We may terminate or suspend your access to the Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach these Terms. Upon termination, your right to use the Service will immediately cease.
        </p>
      </section>

      <section className='faq-section'>
        <h2 className='faq-question'>Entire agreement</h2>
        <p className='faq-answer'>
          These Terms constitute the entire agreement between you and us regarding the use of the Service and supersede all prior agreements and understandings, whether written or oral, between you and us.
        </p>
      </section>

      <section className='faq-section'>
        <h2 className='faq-question'>Contact</h2>
        <p className='faq-answer'>
          If you have any questions about these Terms, please contact us at{' '}
          <a href='mailto:info@tinyinvoice.app'>info@tinyinvoice.app</a>.
        </p>
      </section>

      <p className='faq-back'>{HomeLink}</p>
    </>
  )
}

export default TermsContent
